import r from"./grid.module.scss.js";const s=["sm","md","lg","xl"],o=(o,e)=>s.reduce(((s,m)=>{const t=e?.[m];return{...s,[r[`${o}-${m}-${t}`]]:t}}),{});export{o as generateColClassNames};
